import { useLang } from "../../lib/i18n";
import { useContent, useFetch } from "../../lib/useFetch";

import { Img, GEN } from "../../components/site/Img";

const IMG = GEN.coach;

export const PageHeader = ({ eyebrow, title, sub, img, fallback }) => (
  <section className="grain relative overflow-hidden bg-[#0A2540] pb-20 pt-40 text-white">
    {img && <Img src={img} fallback={fallback} className="absolute inset-0 h-full w-full object-cover opacity-35" />}
    <div className="absolute inset-0 bg-gradient-to-r from-[#0A2540] via-[#0A2540]/70 to-transparent" />
    <div className="container-x relative">
      <p className="eyebrow rise">{eyebrow}</p>
      <h1 className="rise d1 mt-4 max-w-3xl font-display text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">{title}</h1>
      {sub && <p className="rise d2 mt-5 max-w-xl text-white/70">{sub}</p>}
    </div>
  </section>
);

export default function About() {
  const { t, trc, tr } = useLang();
  const c = useContent();
  const { data: coaches } = useFetch("/public/instructors", { cached: true });
  const blocks = [["philosophy", t("philosophy")], ["organization", t("organization")], ["skills", t("skills")], ["history", t("history")]];
  return (
    <div data-testid="about-page">
      <PageHeader eyebrow="Atlantis Academy" title={trc(c, "about", "title")} img={c.images?.fields?.about_header || IMG} fallback={IMG} />
      <section className="container-x grid gap-x-16 gap-y-14 py-24 md:grid-cols-2">
        {blocks.map(([k, label], i) => (
          <div key={k} className="rise" style={{ animationDelay: `${i * 0.1}s` }} data-testid={`about-${k}`}>
            <p className="font-display text-6xl font-black text-[#00A8B5]/20">0{i + 1}</p>
            <h2 className="-mt-6 font-display text-2xl font-bold text-[#0A2540] md:text-3xl">{label}</h2>
            <p className="mt-4 leading-relaxed text-slate-600">{trc(c, "about", k)}</p>
          </div>
        ))}
      </section>
      <section className="bg-white py-24">
        <div className="container-x">
          <p className="eyebrow">Team</p>
          <h2 className="mt-3 font-display text-3xl font-extrabold text-[#0A2540] md:text-5xl">{t("our_coaches")}</h2>
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {(coaches || []).map((p) => (
              <div key={p.id} className="card-lift rounded-3xl border border-slate-200 p-6" data-testid={`coach-card-${p.id}`}>
                {p.photo ? <img src={p.photo} alt={p.name} className="h-48 w-full rounded-2xl object-cover" />
                  : <div className="flex h-48 items-center justify-center rounded-2xl bg-gradient-to-br from-[#0A2540] to-[#00A8B5] font-display text-5xl font-black text-white">{p.name.split(" ").map((x) => x[0]).join("")}</div>}
                <h3 className="mt-5 font-display text-lg font-bold text-[#0A2540]">{p.name}</h3>
                <p className="text-sm font-semibold text-[#FF5722]">{tr(p, "role")}</p>
                <p className="mt-3 text-sm leading-relaxed text-slate-500">{tr(p, "bio")}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
